import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { useContext, useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { scoringApiConnectionCheck } from "../../api/ScoringApi";
import ClearCache from "../../components/ClearCache";
import { IPInput } from "../../components/IPInput";
import LoadingStatus from "../../components/LoadingStatus";
import { Context } from "../../context/FittingContext";
import WebSocketConnection from "../../utils/WebSocketConnection";
import WelcomePopup from "../../components/WelcomePopup";
import { useFeatureFlag } from "../../context/FeatureFlagContext";

const Main = () => {
	const navigate = useNavigate();
	const {
		clubState,
		getClubs,
		getFitters,
		getLocations,
		setSelectedShaft,
		setSelectedHead,
	} = useContext(Context);
	const [connecting, setConnecting] = useState(false);
	const [wsIsConnected, setWsIsConnected] = useState("false");
	const [scoreApiConnected, setScoreApiConnected] = useState("false");
	const { enabled: welcomePopupEnabled } = useFeatureFlag(
		"welcome_popup",
		false
	);
	const { enabled: marginOptimizationEnabled, loading: marginFlagLoading } =
		useFeatureFlag("Margin Optimization", false);
	
	const updateIpAddress = (address) => {
		localStorage.setItem("TrackmanIP", address);
		setConnecting(true);
		setWsIsConnected("false");
		setScoreApiConnected("false");
		getClubs();
		getFitters();
		getLocations();
		scoringApiConnectionCheck(checkScoreApiConnection);
		WebSocketConnection.connect(
			address,
			setWsIsConnected,
			process.env.REACT_APP_MOCK_CALLS === "true"
		);
		setSelectedShaft(undefined);
		setSelectedHead(undefined);
	};

	const checkScoreApiConnection = (connected) => {
		if (connected) {
			setScoreApiConnected("true");
		} else {
			setScoreApiConnected("error");
		}
	};

	// Auto-redirect to fitting page when continuing session
	useEffect(() => {
		const continueSession = localStorage.getItem("continueSession");
		if (continueSession === "true") {
			navigate("/fitting");
		}
	}, [navigate]);

	const isAllConnected = scoreApiConnected === "true" &&
	clubState.fetchedClubInfo === "true" &&
	clubState.fetchedFitters === "true" &&
	clubState.fetchedLocations === "true" &&
	wsIsConnected === "true"

	return (
		<Grid
			container
			flexDirection="column"
			justifyContent="center"
			sx={{
				minHeight: "100vh",
				backgroundColor: "#003F5E",
			}}
		>
			<Grid container>
				<Grid item xs={12} sx={{ position: "absolute", top: 0, right: 15 }}>
					<ClearCache />
				</Grid>

				{welcomePopupEnabled ? (
					<Grid
						item
						xs={12}
						sx={{
							position: "absolute",
							top: 20,
							right: 80,
							width: 250,
							zIndex: 10,
						}}
					>
						<WelcomePopup />
					</Grid>
				) : null}

				<Grid
					item
					xs={12}
					display="flex"
					justifyContent="center"
					alignItems="center"
				>
					<Box display="flex" alignItems="center">
						<img src="Club-Champion-logo.svg" height={200} alt="" />
						<Typography variant="h2" sx={{ color: "white" }}>
							Club Champion A.I. Co-Pilot
						</Typography>
					</Box>
				</Grid>
	
				<Grid item xs={12}>
					<IPInput setIP={updateIpAddress} isConnected={isAllConnected}/>
				</Grid>
				{connecting ? (
					<>
						<Grid
							item
							xs={12}
							display="flex"
							justifyContent="center"
							sx={{ marginTop: 2 }}
						>
							<LoadingStatus
								loading={wsIsConnected}
								displayText={{
									loaded: "Connected to Trackman",
									loading: "Connecting to Trackman",
									error: "There was an error connecting to Trackman",
								}}
							/>
						</Grid>
						<Grid
							item
							xs={12}
							display="flex"
							justifyContent="center"
							sx={{ marginTop: 2 }}
						>
							<LoadingStatus
								loading={clubState.fetchedClubInfo}
								displayText={{
									loaded: "Fetched Club Information",
									loading: "Fetching Club Information",
									error: "There was an issue fetching Club Information",
								}}
							/>
						</Grid>
						<Grid
							item
							xs={12}
							display="flex"
							justifyContent="center"
							sx={{ marginTop: 2 }}
						>
							<LoadingStatus
								loading={clubState.fetchedFitters}
								displayText={{
									loaded: "Fetched Fitter Information",
									loading: "Fetching Fitter Information",
									error: "There was an issue fetching Fitter Information",
								}}
							/>
						</Grid>
						<Grid
							item
							xs={12}
							display="flex"
							justifyContent="center"
							sx={{ marginTop: 2 }}
						>
							<LoadingStatus
								loading={clubState.fetchedLocations}
								displayText={{
									loaded: "Fetched Location Information",
									loading: "Fetching Location Information",
									error: "There was an issue fetching Location Information",
								}}
							/>
						</Grid>
						<Grid
							item
							xs={12}
							display="flex"
							justifyContent="center"
							sx={{ marginTop: 2 }}
						>
							<LoadingStatus
								loading={scoreApiConnected}
								displayText={{
									loaded: "Connected to the Scoring API",
									loading: "Connecting to the Scoring API",
									error: "There was an issue Connecting to the Scoring API",
								}}
							/>
						</Grid>
					</>
				) : null}
				{isAllConnected ? (
					<Grid
						item
						xs={9}
						display="flex"
						justifyContent="right"
						sx={{ marginTop: 2 }}
					>
						<Link to="/fitting" style={{ textDecoration: "none" }}>
							<Button
								variant="contained"
								style={{ backgroundColor: "#00AEEF" }}
							>
								Start Fitting
							</Button>
						</Link>
					</Grid>
				) : null}
			</Grid>
		</Grid>
	);
};

export default Main;
